import axios from 'axios';
import router from '../router/index'

// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
// axios.defaults.headers.get['Content-Type'] = 'application/json';

axios.defaults.transformRequest = [function (data) {
    let ret = ''
    for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
    return ret
}]

let config = {
    //     baseURL: process.env.baseURL || process.env.apiUrl || ""
    timeout: 30 * 1000, // Timeout
    //   withCredentials: true, // Check cross-site Access-Control
}

const _axios = axios.create(config);

// 添加请求拦截器
_axios.interceptors.request.use(
    function (config) {
        // 在发送请求之前做些什么
        return config;
    },
    function (error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 添加响应拦截器
_axios.interceptors.response.use(
    function (response) {
        // 对响应数据做点什么
        if (response.data.code == 2202) {
            var current = router.history.current.path;
            if(current !== '/login') {
                router.replace('/login');
            }
        }
        return response;
    },
    function (error) {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);

export default _axios;

